import {FC, useState, useEffect} from 'react'

import {Modal} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import Api from 'thesis-and-dissertations/helpers/api'

const api = new Api()

type Props = {
  showModal: boolean
  handleCloseModal: any
  email: any
}

const DetailMemberModalContent: FC<Props> = ({showModal, handleCloseModal, email}) => {
  const [show, setShow] = useState<any>(false)
  const [detailProfile, setDetailProfile] = useState<any>({})

  useEffect(() => {
    if (Object.keys(email).length != 0) {
      fetchData()
    }
  }, [email])

  useEffect(() => {
    setShow(showModal)
  }, [showModal])

  const handleClose = () => {
    setShow(false)
    handleCloseModal(false)
  }

  const fetchData = () => {
    api
      .getProfileAwardee({email: email})
      .then((response: any) => {
        const {data} = response.data
        setDetailProfile(data)
      })
      .catch((error: any) => {
      })
  }

  return (
    <Modal show={show} centered size='sm' closeButton>
      <div
        className='d-flex justify-content-end p-5'
        onClick={handleClose}
        style={{cursor: 'pointer'}}
      >
        <span className='fa fa-close' />
      </div>

      <div className='p-5'>
        <div className='text-center'>
          {/* <!-- Avatar --> */}
          <img
            src={detailProfile?.link_foto}
            alt='Avatar'
            className='rounded-4'
            style={{width: '130px', height: '130px', objectFit: 'cover'}}
          />
          {/* <!-- Nama --> */}
          <div className='fw-semibold my-5'>
            <Link
              to={`/crafted/pages/profile/basic-overview?alumni=${detailProfile.users_id_hash}`}
            >
              {detailProfile.nama_lengkap}
            </Link>
          </div>
        </div>

        {/* <!-- Detail Informasi --> */}
        <div className='mb-3' style={{borderBottom: '0.5px solid black'}}>
          <div className='fw-semibold text-black'>Program Beasiswa</div>
          <div style={{color: '#667085'}} className='small mt-2'>
            {detailProfile?.program_beasiswa ?? '-'}
          </div>
        </div>

        <div className='mb-3' style={{borderBottom: '0.5px solid black'}}>
          <div className='fw-semibold text-black'>Universitas</div>
          <div style={{color: '#667085'}} className='small mt-2'>
            {detailProfile?.universitas_tujuan_kontrak
              ? detailProfile?.universitas_tujuan_kontrak
              : '-'}
          </div>
        </div>

        <div className='mb-3' style={{borderBottom: '0.5px solid black'}}>
          <div className='fw-semibold text-black'>Program Studi</div>
          <div style={{color: '#667085'}} className='small mt-2'>
            {detailProfile?.prodi_tujuan_kontrak ? detailProfile?.prodi_tujuan_kontrak : '-'}
          </div>
        </div>

        <div className='mb-3' style={{borderBottom: '0.5px solid black'}}>
          <div className='fw-semibold text-black'>Tanggal Lulus</div>
          <div style={{color: '#667085'}} className='small mt-2'>
            {detailProfile?.awardee_tanggal_lulus ?? '-'}
          </div>
        </div>
      </div>
    </Modal>
  )
}

const DetailMemberModal: FC<Props> = ({showModal, handleCloseModal, email}) => {
  return (
    <DetailMemberModalContent
      showModal={showModal}
      handleCloseModal={handleCloseModal}
      email={email}
    />
  )
}

export default DetailMemberModal
